export function hamburger() {

  
  /*---------------------------------

  ナビ表示・非表示

  ---------------------------------*/

  //ハンバーガーボタン
  const hamburger_trigger = document.querySelector('.js-hamburger');
  //ヘッダーナビ
  const header_nav = document.querySelector('.l-header_nav');
  //コンタクトアイコン
  const contact_ico = document.querySelector('.l-header_hamburger--ico');

  function nav_view() {
    header_nav.animate(
      [
        { opacity: 0 },
        { opacity: 1 }
      ],
      {
        duration: 200,
        fill: 'forwards'
      }
    );
    header_nav.classList.add('is-view');
  }

  function nav_hidden() {
    header_nav.animate(
      [
        { opacity: 1 },
        { opacity: 0 }
      ],
      {
        duration: 200,
        fill: 'forwards'
      }
    );
    setTimeout(() => { 
      header_nav.classList.remove('is-view');
    }, 200);
  }

  function open() {
    hamburger_trigger.classList.add('is-open');
    hamburger_trigger.classList.remove('is-close');
    contact_ico.classList.add('is-view');
    nav_view();
  }

  function close() {
    hamburger_trigger.classList.remove('is-open');
    hamburger_trigger.classList.add('is-close');
    contact_ico.classList.remove('is-view');
    nav_hidden();
  }

  hamburger_trigger.addEventListener('click', () => {
    if ( hamburger_trigger.classList.contains('is-close') == true ) {
      open();
    } else {
      close();
    }
  });


  /*---------------------------------

  メニュークリック

  ---------------------------------*/

  const menu_links = document.querySelectorAll('.l-header_menu--item a');
  for (let index = 0; index < menu_links.length; index++) {
    const menu_link = menu_links[index];
    
    menu_link.addEventListener('click', () => {
      if (window.matchMedia('(max-width: 1024px)').matches) {
        //スマホ処理
        close();
      }
    });
  }
}